import { Signer } from '@modusign/react-signing/types';

export function getSignerDisplayName(signer: Signer) {
  return !signer.name || signer.name.length === 0 ? signer.role : signer.name;
}
